/*jshint browserify: true */
'use strict';

var BoxDrawMode = require('./BoxDrawMode.js');

/**
 * @name AddTickBoxMode
 */
var AddTickBoxMode = (function AddTickBoxModeClosure() {
    function AddTickBoxMode(pdfElements, selectedPdfElements, pages) {
        BoxDrawMode.call(this, pdfElements, selectedPdfElements, pages);
        this.cursor = 'crosshair';
    }

    AddTickBoxMode.prototype = Object.create(BoxDrawMode.prototype);
    AddTickBoxMode.prototype.constructor = AddTickBoxMode;

    AddTickBoxMode.prototype.onMouseUp = function (mouseEvent, page) {
        if (mouseEvent.button === 0 && this._mouseIsDown === true && this._mouseStartPage === page) {
            this._mouseIsDown = false;
            this._mouseEnd = coordinates.Position.fromMouseEvent(mouseEvent, page.pageViewport, page.pdfOverlayCanvasElement);
            this._mouseEndPage = page;

            if (this._mouseStart.pdfX !== this._mouseEnd.pdfY && this._mouseStart.pdfY !== this._mouseEnd.pdfY) {
                var newElement = new PdfTickBoxElement();
                newElement.x = this._mouseStart.pdfX < this._mouseEnd.pdfX ? this._mouseStart.pdfX : this._mouseEnd.pdfX;
                newElement.y = this._mouseStart.pdfY < this._mouseEnd.pdfY ? this._mouseStart.pdfY : this._mouseEnd.pdfY;
                newElement.width = this._mouseStart.pdfX < this._mouseEnd.pdfX ? this._mouseEnd.pdfX - this._mouseStart.pdfX : this._mouseStart.pdfX - this._mouseEnd.pdfX;
                newElement.height = this._mouseStart.pdfY < this._mouseEnd.pdfY ? this._mouseEnd.pdfY - this._mouseStart.pdfY : this._mouseStart.pdfY - this._mouseEnd.pdfY;
                newElement.pageNumber = this._mouseStartPage.pageNumber;

                this.onAddPdfElement(newElement);
            }
        }
    };

    return AddTickBoxMode;
})();

module.exports = AddTickBoxMode;

var coordinates = require('../Coordinates');
var PdfTickBoxElement = require('../Elements/pdf-tick-box-element.js');